import { UseQueryResult } from '@tanstack/react-query'
import { Color } from '@opallabs/gem'
import { Icon } from '@opallabs/lapidary'
import { CurrentUserProvider } from '../Contexts/CurrentUserProvider'
import { useGetWorkflowStatus } from '../queries'
import { WorkflowStatus } from '../types'
import { StatusText } from './StatusText'
import { StatusTitle } from './StatusTitle'
import * as styles from './styles'

export type SidebarStatusProps = {
  entityId: string
  isViewOnly: boolean
  onOpenSidebar: () => void
}

export const SidebarStatus: React.FC<SidebarStatusProps> = ({
  entityId,
  isViewOnly,
  onOpenSidebar,
}) => {
  const workflowStatus = useGetWorkflowStatus({
    entityId,
  }) as UseQueryResult<WorkflowStatus>

  const stageStatus = workflowStatus.data?.activeStage?.declined
    ? 'denied'
    : workflowStatus.data?.approved
      ? 'approved'
      : 'pending'

  return (
    <CurrentUserProvider>
      {/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
      <section
        aria-label="Workflow Status"
        css={styles.base}
        onClick={onOpenSidebar}
      >
        <div>
          <StatusTitle
            activeStageType={workflowStatus.data?.activeStage?.stageType}
            loading={workflowStatus.isInitialLoading}
            stageStatus={stageStatus}
            stageTitle={workflowStatus.data?.activeStage?.title}
            workflowStatus={workflowStatus.data?.state}
          />
          <StatusText status={workflowStatus.data} />
        </div>
        {!isViewOnly && (
          <Icon
            glyph="gem-chevron-e"
            ariaHidden={true}
            color={Color.light.Surface.N000}
          />
        )}
      </section>
      {/* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
    </CurrentUserProvider>
  )
}
